import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule, MatSelectModule } from '@angular/material';

import { MyFilterPipe } from './myfilter.pipe';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { DbmList2Component } from './dbm-list2.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        PipesModule,
        DirectivesModule,
        MatCheckboxModule,
        MatSelectModule
    ],
    declarations: [
        MyFilterPipe,
        DbmList2Component
    ],
    providers: [MyFilterPipe],
    exports: [DbmList2Component, MyFilterPipe],
    entryComponents: [DbmList2Component]
})
export class DbmList2Module {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-list2/dbm-list2.module.ts